import { createContext, Dispatch, ReactNode, SetStateAction, useContext } from 'react';

export type FormErrorContextType = {
	errors: Record<string, { message: string | null | undefined; setPage?: () => void } | null | undefined>;
	setErrors: Dispatch<SetStateAction<Record<string, { message: string | null | undefined; setPage?: () => void } | null | undefined>>>;
	clearSubmissionState: () => void;
};

const Context = createContext<FormErrorContextType | undefined>(undefined);

export const FormErrorContextProvider = ({
	errors,
	setErrors,
	clearSubmissionState,
	children
}: FormErrorContextType & { children: ReactNode }) => {
	return <Context.Provider value={{ errors, setErrors, clearSubmissionState }}>{children}</Context.Provider>;
};

export const useFormErrorContext = () => {
	const context = useContext(Context);
	return context;
};

Context.displayName = 'FormErrorContext';
